/**
 * Calculates what percentage `value` represents of `goal`.
 * Returns 0 when goal is falsy to avoid division by zero.
 */
export const calculatePercentage = (value: number, goal: number): number => {
  if (!goal) return 0
  return (Number(value) * 100) / Number(goal)
}
